import { apiReq } from "../utils/api/apiReq";

export async function signInWithTeams(teamsToken: string) {
	// Token is set by the server using the set-cookie header
	await apiReq("POST", "/v1/signIn/teams", { token: teamsToken });
	return true;
}

export async function validateDomain(domain: string) {
	await apiReq("GET", `/v1/signIn/domain/${domain}`);
}
